var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83333 12.2C4.83333 12.6469 4.45833 13.0125 4 13.0125C3.54167 13.0125 3.16667 12.6469 3.16667 12.2C3.16667 11.7531 3.54167 11.3875 4 11.3875C4.45833 11.3875 4.83333 11.7531 4.83333 12.2ZM7 10.575C7 10.7477 6.84375 10.9 6.66667 10.9H1.33333C1.15625 10.9 1 10.7477 1 10.575V3.425C1 3.25234 1.15625 3.1 1.33333 3.1H6.66667C6.84375 3.1 7 3.25234 7 3.425V10.575ZM5 1.9625C5 2.05391 4.92708 2.125 4.83333 2.125H3.16667C3.07292 2.125 3 2.05391 3 1.9625C3 1.87109 3.07292 1.8 3.16667 1.8H4.83333C4.92708 1.8 5 1.87109 5 1.9625ZM8 1.8C8 1.08906 7.39583 0.5 6.66667 0.5H1.33333C0.604167 0.5 0 1.08906 0 1.8V12.2C0 12.9109 0.604167 13.5 1.33333 13.5H6.66667C7.39583 13.5 8 12.9109 8 12.2V1.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a24392a8d78cad1996f40b5f1f630b5c.svg";
export { ForwardRef as ReactComponent };